import { render, staticRenderFns } from "./HiboButton.vue?vue&type=template&id=876a46da&"
import script from "./HiboButton.vue?vue&type=script&lang=ts&"
export * from "./HiboButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports